import React from 'react';
import { motion } from 'framer-motion';
export function CTA() {
  return <section id="kontakt" className="w-full bg-white py-24 px-6 scroll-mt-20" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-br from-mist to-white rounded-2xl p-12 md:p-16 text-center shadow-lg border border-mist/50" data-id="element-70">
          {/* Sail logomark — navy SVG, plain img on light bg */}
          <img src="https://cdn.magicpatterns.com/uploads/oR2yze7yVUcg2uRAatZj5v/FCh_logo_Blue.svg" alt="Future Challenge logo" width="64" height="64" className="h-16 w-auto block mx-auto mb-8 opacity-80" data-id="element-71" />

          <h2 className="text-3xl md:text-4xl font-light text-navy-deep mb-6" data-id="element-72">
            Doplňující informace
          </h2>

          <div className="text-lg text-navy-deep/70 leading-relaxed mb-10 space-y-4 max-w-2xl mx-auto" data-id="element-73">
            <p data-id="element-74">
              Organizace akce bude koncipována tak, že není nutná přítomnost
              posádek fyzicky na jednom místě nebo skipper meetincích. Veškeré
              informace potřebné k platné účasti budou předávány elektronickou
              formou s dostatečným předstihem do společné WhatsApp skupiny
              kapitánů.
            </p>
            <p data-id="element-75">
              Organizátor nabídne v průběhu akce i pár „workshopů“ na různá
              témata dle zájmů posádek. Nabyté dovednosti tak budete moci ihned
              uplatnit v praxi.
            </p>
          </div>

          <div className="pt-8 border-t border-mist/80" data-id="element-76">
            <p className="text-xl font-serif-italic text-blue-medium mb-4" data-id="element-77">
              „S přáním stálého větru alespoň stopu pod kýlem a pozitivních
              zážitků."
            </p>
            <p className="font-semibold text-navy-deep tracking-wide uppercase text-sm" data-id="element-78">
              — FUTURE Challenge Crew
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}